<!--
 * @Description: 专题页模版配置
 * @Author: wuxuebing
 * @Date: 2024-07-10 08:51:21
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-11 14:34:42
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\topic-page-management\template-configuration\index.vue
-->
<template>
  <div class="h100">
    <filter-layout @search="searchResult" @reset="resetSerach">
      <template #filter>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchRef"
          label-width="140px"
          :model="searchForm"
        >
          <el-form-item label="专题页模版名称">
            <el-input
              :placeholder="'请输入'"
              clearable
              v-model="searchForm.sname"
              size="small"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <div class="content-header">
          <div class="title"></div>
          <div class="mt10 mb10 fr">
            <!-- <el-button
              type="primary"
              class="btn-blue"
              size="small"
              @click="changeState"
            >
              筛选
              <i v-if="searchToggle" class="el-icon-caret-bottom ml5"></i>
              <i v-else class="el-icon-caret-top ml5"></i>
            </el-button> -->
            <el-button
              size="small"
              class="btn-blue"
              icon="el-icon-refresh"
              type="primary"
              @click="resetSerach"
            ></el-button>
          </div>
        </div>
        <div class="w-table-layout w-table-page">
          <div class="w-table-content" v-show="tableShow">
            <el-table
              ref="xTable"
              highlight-current-row
              :data="filterData"
              height="100%"
              border
            >
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="sname"
                label="专题页模版名称"
                header-align="left"
                width="310"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="menus"
                label="包含菜单"
                header-align="left"
                min-width="200"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="useTenants"
                label="使用单位"
                header-align="left"
                min-width="100"
                show-overflow-tooltip
              >
                <template #default="{ row }">
                  <span class="color-blue" @click="changeBtn('unitDetail', row)"
                    >{{ row.useTenants }}家</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label="状态"
                align="left"
                width="200"
                show-overflow-tooltip
              >
                <template #default="{ row }">
                  <span v-if="row.status == 1">启用</span>
                  <span v-if="row.status == 0" class="color-red">禁用</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="createUser"
                label="创建人"
                align="left"
                width="200"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="createDate"
                label="创建时间"
                align="left"
                width="200"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column align="left" width="200" label="操作">
                <template #default="{ row }">
                  <el-button
                    type="primary"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    @click="changeBtn('detail', row)"
                  >
                    查看
                  </el-button>
                  <el-button
                    type="primary"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    @click="changeBtn('edit', row)"
                  >
                    编辑
                  </el-button>
                  <el-button
                    type="primary"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    @click="changeBtn('view', row)"
                  >
                    预览
                  </el-button>
                </template>
                <!--
				  <template slot="header">操作</template>

				  <template slot-scope="scope">

				  </template> -->
              </el-table-column>
            </el-table>
          </div>
          <div class="w-table-footer">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageList"
              :page-size="pageSize"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </filter-layout>
    <!--新增-->
    <el-dialog
      v-model="dialogObj"
      :visible.sync="dialogObj.visible"
      class="primary-dialog"
      width="1000px"
      :title="dialogObj.title"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div v-if="dialogObj.model != 'unitDetail'">
        <el-form
          :model="infoForm"
          label-width="170px"
          size="small"
          ref="infoForm"
          :rules="valueRules"
          :show-message="false"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="专题页模版名称" prop="sname">
                <el-input
                  v-model="infoForm.sname"
                  placeholder="请输入"
                  :disabled="dialogObj.model == 'detail'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="状态" prop="status">
                <el-radio-group
                  v-model="infoForm.status"
                  :disabled="
                    dialogObj.model == 'detail' || infoForm.useTenants > 0
                  "
                >
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  placeholder="请输入"
                  :rows="4"
                  v-model="infoForm.remark"
                  :disabled="dialogObj.model == 'detail'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-if="dialogObj.model == 'unitDetail'">
        <div class="display-flex">
          <el-form
            :model="unitSearchForm"
            label-width="70px"
            class="search-form"
          >
            <el-form-item label="单位名称">
              <el-input
                :placeholder="'请输入'"
                clearable
                v-model="unitSearchForm.sname"
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <div>
            <el-button
              type="primary"
              class="btn-blue ml10"
              size="small"
              @click="searchResultUnit"
              >查询</el-button
            >
            <el-button type="warning" size="small" @click="resetSerachUnit"
              >重置</el-button
            >
          </div>
        </div>
        <div class="w-table-content" v-show="tableShow">
          <el-table
            ref="xTable"
            highlight-current-row
            :data="unitTbale"
            height="500px"
            border
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="sname"
              label="单位名称"
              header-align="left"
              width="310"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="creditCode"
              label="社会统一信用代码"
              header-align="left"
              min-width="200"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="temName"
              label="入驻日期"
              header-align="left"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="proprietor"
              label="企业主"
              header-align="left"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </div>
        <div class="w-table-footer mt10" style="text-align: center">
          <el-pagination
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="currentPage2"
            :page-sizes="pageList2"
            :page-size="pageSize2"
            :total="total2"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer text-center"
        v-if="dialogObj.model == 'edit'"
      >
        <el-button class="btn" size="small" @click="dialogObj.visible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="small"
          class="btn btn-blue"
          :loading="btnLoading"
          @click="doSave"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
	getAllTag,
	getUserTenantPage,
	savePageTem,
} from "api/modules/templateConfiguration";

export default {
  name: "template-configuration",
  data() {
    return {
      searchForm: {
        status: "",
        sname: "",
      },
      options: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 0,
          label: "禁用",
        },
      ],
      searchToggle: true,
      tableShow: true,
      filterData: [],
      loading: false,
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      btnLoading: false,
      dialogObj: {
        title: "",
        visible: false,
        model: "",
      },
      infoForm: {
        sname: "",
        status: 1,
        remark: "",
      },
      valueRules: {
        sname: [{ required: true, message: "请输入", trigger: "change" }],
        status: [{ required: true, message: "请输入", trigger: "change" }],
      },
      unitSearchForm: {
        sname: "",
      },
      unitTbale: [],
      currentPage2: 1, // 当前页码
      pageList2: [10, 20, 50, 100], // 显示条数数组
      pageSize2: 10, // 当前显示条数
      total2: 0, // 当前总条数
    };
  },
  created() {
    this.getData();
  },
  methods: {
    //查询
    searchResult() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.getData();
    },
    //重置
    resetSerach() {
      this.searchForm = {};
      this.currentPage = 1;
      this.pageSize = 10;
      this.getData();
    },
    //列表
    getData() {
      let params = Object.assign({}, this.searchForm);
      this.loading = true;
      // 分页参数
      params.current = this.currentPage;
      params.size = this.pageSize;

      getAllTag(params)
        .then((res) => {
          this.loading = false;
          this.filterData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 是否展开搜索区域
    changeState() {
      this.searchToggle = !this.searchToggle;
    },
    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    //按钮操作
    changeBtn(type, row) {
      switch (type) {
        case "edit":
          // Object.keys(this.infoForm).forEach(
          //   (key) => (this.infoForm[key] = row[key])
          // );
          this.infoForm = row;
          this.dialogObj.visible = true;
          this.dialogObj.title = "编辑";
          this.dialogObj.model = "edit";
          break;
        case "detail":
          this.infoForm = row;
          this.dialogObj.visible = true;
          this.dialogObj.title = "查看";
          this.dialogObj.model = "detail";
          break;
        case "view":
          let url = `${process.env.VUE_APP_PAGE_URL}NgsAzcWeb/#/topicPageManagement/1/91340100788583079J`;
          window.open(url, "_blank");
          break;
        case "unitDetail":
          this.dialogObj.visible = true;
          this.dialogObj.title = "使用单位";
          this.dialogObj.model = "unitDetail";
          this.getUnit(row.id);
          break;
      }
    },
    doSave() {
      //校验表单
      this.$refs["infoForm"].validate((valid) => {
        if (valid) {
          let params = { ...this.infoForm };
          this.btnLoading = true;
          savePageTem(params)
            .then((res) => {
              this.btnLoading = false;
              this.$message.success("操作成功");
              this.handleClose();
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          this.$message.error("请完善表单！");
        }
      });
    },

    //获取入驻单位
    searchResultUnit() {
      this.currentPage2 = 1;
      this.pageSize2 = 10;
      this.getUnit();
    },
    resetSerachUnit() {
      this.unitSearchForm = {};
      this.currentPage2 = 1;
      this.pageSize2 = 10;
      this.getUnit();
    },
    //切换当前页码
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.getUnit();
    },
    // 切换显示条数
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getUnit();
    },
    getUnit(id) {
      let params = { ...this.unitSearchForm };
      params.current = this.currentPage;
      params.size = this.pageSize;
      params.id = id;
      getUserTenantPage(params)
        .then((res) => {
          this.loading = false;
          this.unitTbale = res.data.records;
          this.currentPage2 = parseInt(res.data.current);
          this.total2 = parseInt(res.data.total);
          this.pageSize2 = parseInt(res.data.size);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleClose() {
      //刷新列表
      this.getData();
      this.dialogObj.visible = false;
      this.dialogObj.model = "";
      this.dialogObj.title = "";
    },
  },
  watch: {
    // 监听 筛选元素的 切换展示 重新调整表格高度
    searchToggle() {
      this.tableShow = false;
      setTimeout(() => {
        this.tableShow = true;
      }, 50);
      setTimeout(() => {
        this.$refs.xTable.doLayout();
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.display-flex {
  display: flex;
  justify-content: space-between;
}
.color-red {
  color: red;
}
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    padding-left: 10px;
    border-left: 4px solid #2671cc;
    font-size: 14px;
    color: #202020;
  }
  .blue {
    font-size: 18px;
    color: #2671cc;
  }
}
</style>
